import type { IconProps } from './types';

export const AmazonColorIcon = (props: IconProps) => {
  const { size = 20, ref, ...other } = props;

  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...other}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.4821 19.0569C23.4182 18.9685 23.3537 18.8819 23.2897 18.7958C22.7687 18.0956 22.2723 17.4282 22.2723 16.0905V11.1034C22.2723 10.93 22.2733 10.7578 22.2743 10.587C22.2856 8.67484 22.296 6.93005 20.8659 5.59526C19.6395 4.41605 17.6024 4 16.0444 4C12.9974 4 9.59828 5.13641 8.88546 8.90215C8.81001 9.30214 9.10055 9.51152 9.36394 9.57038L12.4666 9.90614C12.7571 9.89139 12.9669 9.60582 13.0232 9.31819C13.2892 8.02057 14.376 7.39718 15.597 7.39718C16.2556 7.39718 17.0034 7.63798 17.3932 8.22861C17.7951 8.81749 17.7888 9.60385 17.7831 10.307C17.7824 10.3889 17.7817 10.4697 17.7817 10.5489V10.9669C17.4938 10.9991 17.1922 11.0296 16.8815 11.061C15.1894 11.2321 13.2288 11.4303 11.7605 12.0739C9.7558 12.9421 8.34808 14.7086 8.34808 17.3051C8.34808 20.6328 10.4428 22.2962 13.1397 22.2962C15.4158 22.2962 16.6613 21.7591 18.4171 19.9693C18.5048 20.0964 18.5837 20.2135 18.6579 20.3239C19.0768 20.9466 19.3501 21.3531 20.2524 22.1036C20.4906 22.2307 20.8057 22.226 21.0168 22.0347C21.6561 21.4662 22.817 20.4575 23.4715 19.9091C23.7329 19.6944 23.6866 19.3472 23.4821 19.0569ZM17.1828 17.6189C16.6746 18.5218 15.8651 19.0743 14.9657 19.0743C13.7393 19.0743 13.0192 18.1379 13.0192 16.7526C13.0192 14.0257 15.4667 13.5307 17.7811 13.5307C17.7811 13.6939 17.7826 13.8579 17.7841 14.0224C17.7955 15.2569 17.807 16.5158 17.1828 17.6189Z"
        fill="#040707"
      />
      <path
        d="M27.3087 24.4988C24.2439 26.7841 19.7994 28 15.9717 28C10.6092 28 5.77885 25.9968 2.1238 22.6618C1.8371 22.3996 2.09299 22.0415 2.43743 22.2451C6.38148 24.5645 11.258 25.9607 16.2945 25.9607C19.6925 25.9607 23.4271 25.2487 26.8634 23.7748C27.3817 23.5532 27.8162 24.1209 27.3087 24.4988Z"
        fill="#F8981D"
      />
      <path
        d="M25.0052 22.9071C25.992 22.7866 28.1923 22.52 28.584 23.0267C28.9762 23.533 28.1525 25.6149 27.7812 26.5532L27.7785 26.56C27.6667 26.843 27.907 26.9559 28.1601 26.7415C29.8048 25.352 30.2297 22.4392 29.8927 22.0171C29.5583 21.6008 26.6831 21.2404 24.9285 22.4859C24.6589 22.679 24.705 22.9423 25.0052 22.9071Z"
        fill="#F8981D"
      />
    </svg>
  );
};
